import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FateDropdown } from 'fate-editor';

/**Componente per la dropdown dei caratteri accentati */
@Component({
  selector: 'app-accented-char-dropdown',
  templateUrl: './accented-char-dropdown.component.html',
  styleUrls: ['../editor-dropdowns.css']
})
export class AccentedCharDropdownComponent implements FateDropdown {
  /**Input, la stringa eventualmente selezionata */
  @Input()
  public value: string;
  /**Emettitore per il valore selezionato da dropdown */
  @Output() public valueChange = new EventEmitter<string>();

  /**Lista dei possibili valori di carattere accentato */
  noteList = ['à', 'è', 'ì', 'ò', 'ù', "á", "é", "í", 'ó', 'ú', 'À', 'È', 'Ì', 'Ò', 'Ù', 'Á', 'É', 'Í', 'Ó', 'Ú']

  /**Indice elemento selezionato */
  public selected = 0;

  /**
   * Metodo che gestisce l'emissione del valore selezionato
   * @param value {any} il valore selezionato
   */
  public changeValue(value) {
    this.valueChange.emit(value);
  }

  /**Metodo che gestisce la selezione del successivo sull'elenco dei possibili caratteri */
  public selectNext() {
    this.selected++;
    if (this.selected >= this.noteList.length) {
      this.selected = this.noteList.length - 1;
    }
  };
  /**Metodo che gestisce la selezione del precedente sull'elenco dei possibili caratteri */
  public selecPrevious() {
    this.selected--;
    if (this.selected < 0) {
      this.selected = 0;
    }
  };
  
  /**Metodo che conferma la selezione lanciando il metodo di cambio valore */
  public confirmSelection() {
    this.changeValue(this.noteList[this.selected]);
  };
  constructor() { }

}
